import { validateFieldsForCURP, validateFieldsforRFC } from '../../../../../utils/form/validationUtils';
import { generateCURP } from '../../../../../utils/curp';
import { generateRFC } from '../../../../../utils/rfc/rfcGenerator';
import { formatDOB } from '../../../../../utils/form/formatDOB';

// Get the generated CURP based on the provided values
export const getGeneratedCurp = values => {
  const {
    names, firstSurname, secondSurname, gender, entity,
    day, month, year,
  } = values;
  const formattedDOB = formatDOB(day, month, year);
  if (validateFieldsForCURP({
    names, firstSurname, dob: formattedDOB, gender, entity,
  })) {
    return generateCURP({
      names, firstSurname, secondSurname, dob: formattedDOB, gender, entity,
    });
  }
  return '';
};

// Get the generated RFC based on the provided values
export const getGeneratedRfc = values => {
  const {
    names, firstSurname, secondSurname, day, month, year,
  } = values;
  const formattedDOB = formatDOB(day, month, year);
  if (validateFieldsforRFC({ names, firstSurname, dob: formattedDOB })) {
    return generateRFC({
      names, firstSurname, secondSurname, dob: formattedDOB,
    });
  }
  return '';
};
